import { useState } from 'react';
import propTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import HelperIcon from 'src/shared/components/HelperIcon';
import { Trans } from 'react-i18next';
import { makeStyles, useTheme } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  tooltip: {
    borderRadius: '5px',
    fontSize: '12px',
    lineHeight: '16px',
    padding: '12px'
  }
}));

const HelperIconWithTooltip = ({ title, className = '', disablePortal = true }) => {
  const theme = useTheme();
  const classes = useStyles();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const handleTooltipClose = () => {
    setTooltipOpen(false);
  };

  const handleTooltipOpen = () => {
    setTooltipOpen(true);
  };
  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div className={className} onClick={handleTooltipOpen}>
        <Tooltip
          PopperProps={{
            disablePortal
          }}
          placement="top"
          onClose={handleTooltipClose}
          open={tooltipOpen}
          disableFocusListener
          disableHoverListener
          arrow
          title={<Trans i18nKey={title} ns="flexflow" components={[<strong />]} />}
          classes={{ tooltip: classes.tooltip }}
        >
          <div>
            <HelperIcon color={theme.palette.colorPalette[1]} hoverColor={theme.palette.text.primary} />
          </div>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

HelperIconWithTooltip.propTypes = {
  title: propTypes.string,
  className: propTypes.string
};

export default HelperIconWithTooltip;
